exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".child-option-checkbox {\n  padding: 5px;\n  margin: 5px 20px;\n}", ""]);

